import { useCallback, useEffect, useRef } from "react";
export function useMeetingTabCloseWarning(enabled) {
    const allowTabCloseRef = useRef(false);
    const allowTabClose = useCallback(() => {
        allowTabCloseRef.current = true;
    }, []);
    useEffect(() => {
        if (!enabled) {
            return;
        }
        const handleBeforeUnload = (event) => {
            if (allowTabCloseRef.current) {
                return;
            }
            event.preventDefault();
            event.returnValue = "";
        };
        window.addEventListener("beforeunload", handleBeforeUnload);
        return () => {
            window.removeEventListener("beforeunload", handleBeforeUnload);
        };
    }, [enabled]);
    return { allowTabClose };
}
